<template>
    <multiselect
        v-model="selection"
        track-by="id"
        label="name"
        tag-placeholder="Press enter to add"
        class="tringy-tag"
        @tag="addTag"
        :no-options="noOptions"
        :placeholder="placeholder"
        :options="adjustedOptions"
        :multiple="true"
        :taggable="true"
        :close-on-select="closeOnSelect"
        :show-labels="showLabels"
        :class="{ 'has-selection': hasSelection }"
    >
        <span slot="caret">
            <div class="multiselect__select" v-if="showCaret"></div>
        </span>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    components: { Multiselect },
    props: {
        placeholder: {
            default: null,
        },
        value: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: false,
        },
        noOptions: {
            type: String,
            default: 'List is empty',
        },
        showLabels: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: false,
        },
        showCaret: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selection: [],
        };
    },
    computed: {
        hasSelection() {
            return !_.isEmpty(this.selection);
        },
        adjustedOptions() {
            return this.options ? this.options : this.selection;
        },
    },
    methods: {
        addTag(newTag) {
            const tag = {
                id: newTag,
                name: newTag,
            };

            this.selection.push(tag);
        },
    },
    watch: {
        selection: {
            deep: true,
            handler(newVal) {
                this.$nextTick(() => {
                    this.$emit(
                        'input',
                        _.map(newVal, (item) => item.name),
                    );
                });
            },
        },
    },
};
</script>
